import { render } from "./WorkGallery.vue?vue&type=template&id=1a9e5f81&scoped=true"
import script from "./WorkGallery.vue?vue&type=script&lang=js"
export * from "./WorkGallery.vue?vue&type=script&lang=js"

import "./WorkGallery.vue?vue&type=style&index=0&id=1a9e5f81&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a9e5f81"]])

export default __exports__